export default __webpack_public_path__ + "static/cert-3-img-fc03611006ce8c90d6c114bc5db90ce1.png";